<template>
  <div class="navigation-right-side">
    <div class="d-flex flex-column align-items-center justify-content-center gap-2">
      <el-tooltip
        :content="isShowDeformationEditor ? $t('views.sidebar-tools.close-deformation-editor') : $t('views.sidebar-tools.show-deformation-editor')"
        placement="left"
      >
        <el-button :disabled="isLoading || productTypeId && productTypeId !== 1" type="primary" class="ml-0" size="large" circle @click="closeDeformationEditor()">
          <font-awesome-icon :icon="isShowDeformationEditor ? 'close' : 'tv'" class="dynamic-color" />
        </el-button>
      </el-tooltip>
<!--      <el-tooltip v-if="isUserSupplier" :content="$t('views.sidebar-tools.component-list')" placement="left">-->
<!--        <el-button :disabled="isLoading" type="primary" class="ml-0" title="Config" size="large" circle @click="$emit('showComponentsModalDialog')">-->
<!--          <font-awesome-icon icon="cubes" class="dynamic-color" />-->
<!--        </el-button>-->
<!--      </el-tooltip>-->
      <el-tooltip v-if="isShowDeformationEditor" :content="$t('views.sidebar-tools.product-configuration')" placement="left">
        <el-button :disabled="isLoading || productTypeId && productTypeId !== 1" type="primary" class="ml-0" title="Config" size="large" circle @click="$emit('showProductParameterModalDialog')">
          <font-awesome-icon icon="sliders" class="dynamic-color" />
        </el-button>
      </el-tooltip>
      <el-tooltip v-if="isShowDeformationEditor && isUserSupplier" :content="$t('views.sidebar-tools.download-3d-file')" placement="left">
        <el-button :disabled="isLoading" type="primary" class="ml-0" size="large" circle @click="download3DFileToObj()">
          <font-awesome-icon icon="file-arrow-down" class="dynamic-color" />
        </el-button>
      </el-tooltip>
      <el-tooltip v-if="!isShowDeformationEditor" :content="$t('views.sidebar-tools.export-pdf')" placement="left">
        <el-button :disabled="isLoading" type="primary" class="ml-0" size="large" circle @click="exportPDF()">
          <font-awesome-icon icon="file-pdf" class="dynamic-color" />
        </el-button>
      </el-tooltip>
    </div>
  </div>
</template>

<script lang="ts">
import { RendererPublicInterface } from 'troisjs';
import { Vue, Component, Prop, Watch } from 'vue-facing-decorator';
import { ElMessage } from 'element-plus';

import { createPDFRenderObjectView, generatePDF } from '@/utils/pdfTemplates';
import * as THREEEnum from '@/types/enum/three';
import { MeshTreeData } from '@/types/ui/MeshTreeData';
import AlertLoading from '@/components/ui-elements/AlertLoading.vue';
import { BlobURL } from '@/types/interfaces/blobUrl';
import * as THREE from 'three';
import { Role } from '@/types/enum/user';
import { useUserStore } from '@/stores/userStore';

interface CameraData {
  cameraId: number | null;
  name: string;
  view: THREEEnum.Views;
  perspective: boolean;
}

@Component({
  components: {
    AlertLoading,
  },
  emits: ['showComponentsModalDialog', 'showProductParameterModalDialog', 'download3DFileToObj', 'closeDeformationEditor'],
})

export default class SidebarRightTools extends Vue {
  @Prop() modelValue!: MeshTreeData;
  @Prop({ default: null }) productTypeId!: number | null;
  @Prop({ default: false }) isLoading!: boolean;
  @Prop({ default: false }) isLoadingDownloadObject!: boolean;
  @Prop({ default: 'Product name' }) filename!: string;
  @Prop() troisRenderer!: RendererPublicInterface;
  @Prop({ default: false }) isShowDeformationEditor!: boolean;
  @Prop({ default: false }) isDeformationActive!: boolean;
  @Prop({ default: false }) isLoadingDeformation!: boolean;
  //@Prop({ default: false }) isUserSupplier!: boolean;

  isloadingDownloadPDF = false;
  isShowAlert = false;
  cameraData: CameraData = {
    cameraId: null,
    name: THREEEnum.Views.custom,
    view: THREEEnum.Views.custom,
    perspective: true,
  };
  isUserSupplier = false;
  userStore = useUserStore();
  @Watch('userStore.roles')
  onRolesChanged(): void {
    this.isUserSupplier = this.userStore.roles.includes(Role.Supplier);
  }
mounted(){
  this.onRolesChanged()
}
  renderCamera(camera: THREE.Camera | undefined, returnBlobURL = false): Promise<string> {
    return new Promise((resolve) => {
      if (this.troisRenderer.scene && camera) {
        this.troisRenderer.renderer.clear();
        this.troisRenderer.renderer.render(this.troisRenderer.scene, camera);
      }

      this.troisRenderer.canvas.toBlob((blob) => {
        if (blob) {
          const blobURL = URL.createObjectURL(blob);
          if (!returnBlobURL) {
            window.open(blobURL, '_blank');
          }
          resolve(blobURL);
        } else {
          resolve('');
        }
      });
    });
  }

  async customAlert(type: string, duration: number): Promise<void> {
    const message = type === 'warning' ? 'warning.message.downloadProcess' : 'success.message.successfulDownload';

    ElMessage({
      dangerouslyUseHTMLString: false,
      grouping: false,
      message: this.$t(message),
      type: type as 'success' | 'warning' | 'info' | 'error',
      customClass: 'custom-message-bottom-right',
      duration: duration,
      showClose: true,
    });
  }

  async download3DFileToObj(): Promise<void> {
    await this.customAlert('warning', 5000);
    setTimeout(async () => {
      await this.$emit('download3DFileToObj');
      await this.customAlert('success', 3000);
    }, 5000);
  }

  async exportPDF(): Promise<void> {
    this.customAlert('warning', 3000);
    this.isloadingDownloadPDF = true;
    // Get object 3D image url
    const blobUrl = await this.renderCamera(this.troisRenderer.camera, true);

    // Craete PDF template
    const blobURLs: BlobURL = {
      uuid: null,
      name: this.filename,
      blobUrl,
    };
    const content = createPDFRenderObjectView([blobURLs]);
    // Generate PDF

    generatePDF(content, this.filename);
    this.isloadingDownloadPDF = false;
    this.customAlert('success', 3000);
  }

  closeDeformationEditor(): void {
    this.$emit('closeDeformationEditor');
  }
}
</script>

<style lang="scss" scoped>
.navigation-right-side {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translate(0, -50%);
  min-width: 50px;
  min-height: 100px;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  z-index: 100;
  padding: 10px;
  background-color: rgb(255 255 255 / 60%); /* White with 50% opacity */
  backdrop-filter: blur(30px); /* Blur effect */
  -webkit-backdrop-filter: blur(30px);
  box-shadow: 0 4px 20px rgb(0 0 0 / 7%);
}


.navigation-right-side .el-button + .el-button {
  margin-left: 0 !important;
}

.custom-message-bottom-right {
  position: fixed !important;
  bottom: 20px !important;
  right: 20px !important;
  z-index: 9999;
}
.dynamic-color {
  color: var(--primary-text);
}

@media (max-width: 828px) {

  .navigation-right-side{
    display: none;
  }

}

</style>
